var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialOksvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_874_11891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99629 8.2672C7.35789 8.2672 9.26829 6.4192 9.26829 4.1336C9.26749 1.848 7.35709 0 4.99549 0C2.63389 0 0.724292 1.848 0.724292 4.1336C0.724292 6.3952 2.63469 8.2672 4.99629 8.2672ZM4.99629 2.432C5.97629 2.432 6.75549 3.2096 6.75549 4.1336C6.75549 5.0824 5.95149 5.836 4.99629 5.836C4.01629 5.836 3.23789 5.0576 3.23789 4.1336C3.23789 3.1856 4.01629 2.432 4.99629 2.432ZM6.72989 11.6232L9.09149 13.9328C9.56909 14.3952 9.56909 15.1728 9.09149 15.6352C8.61469 16.0976 7.81069 16.0976 7.33309 15.6352L4.99629 13.3736L2.66029 15.6352C2.54493 15.7511 2.40778 15.8429 2.25675 15.9055C2.10572 15.9681 1.94379 16.0003 1.78029 16C1.45389 16 1.15229 15.8784 0.900292 15.6352C0.786892 15.5243 0.696787 15.3919 0.63527 15.2458C0.573754 15.0996 0.542065 14.9426 0.542065 14.784C0.542065 14.6254 0.573754 14.4684 0.63527 14.3222C0.696787 14.1761 0.786892 14.0437 0.900292 13.9328L3.28829 11.624C2.41107 11.4262 1.57113 11.0895 0.800292 10.6264C0.197092 10.2616 0.0210923 9.5072 0.398692 8.948C0.578958 8.66882 0.861679 8.47163 1.18594 8.3989C1.51021 8.32618 1.85006 8.38375 2.13229 8.5592C3.00007 9.0841 3.99492 9.36157 5.00909 9.36157C6.02327 9.36157 7.01812 9.0841 7.88589 8.5592C8.48909 8.2192 9.24269 8.3888 9.61949 8.948C9.97149 9.532 9.79549 10.2616 9.21709 10.6264C8.44645 11.0891 7.60679 11.4256 6.72989 11.6232Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_874_11891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.6,
    height: 16,
    fill: "white",
    transform: "translate(0.200195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialOksvg);
export default __webpack_public_path__ + "static/media/social-ok.svg.6b5520a513a74336396f4fd8d91e4bfd.svg";
export { ForwardRef as ReactComponent };